export { brightEdgePlugin } from "./bright-edge";
export type { Plugin, BaseSitecorePageProps } from "./bright-edge";
